import { create } from 'zustand'

const BuildState = create<BuildStateInterface>((set) => {
    const BuildInitialState: BuildStateInterface = {
        Selects: [],
        SetState: (payload: BuildStateInterface) => set((state: BuildStateInterface) => ({
            ...state,
            ...payload
        }))
    }

    return BuildInitialState
})

export default BuildState
